import * as yup from 'yup';

export const createPasswordSchema = yup.object().shape({
    password: yup.string().required(),
    repeatPassword: yup
        .string()
        .oneOf([yup.ref('password'), null])
        .required(),
});
